import { useState } from 'react';
import { useCurrentUser, useHasPermissions, useUserActions } from 'stores/useUserStore';

import { MenuItem } from 'components/ui/menus/MenuButton';
import { ElementTestId } from 'enums/testing';
import { impersonationManager } from 'utils/impersonationUtils';
import { translate } from 'utils/intlUtils';

import { AccessLevel, ResourceType } from 'store/client/graphql';

import UserSelector from './UserSelector';

const { t } = translate;

const ImpersonationToggle = () => {
  const hasImpersonatePermission = useHasPermissions([{ level: AccessLevel.FULL, resource: ResourceType.AS_USER }]);
  const { impersonateAsUser } = useUserActions();
  const { displayName, id } = useCurrentUser();

  const [isUserSelectorOpen, setUserSelectorOpen] = useState<boolean>(false);

  if (!hasImpersonatePermission && !impersonationManager.isCurrentlyImpersonating) {
    return null;
  }

  if (impersonationManager.isCurrentlyImpersonating) {
    return (
      <MenuItem
        label={t('logout_of_user', [displayName])}
        onClick={() => impersonateAsUser(undefined)}
        testId={ElementTestId.LOGOUT_OF_USER_MENU_ITEM}
      />
    );
  }

  return (
    <>
      <MenuItem
        label={t('login_as_user')}
        onClick={() => setUserSelectorOpen(true)}
        testId={ElementTestId.LOGIN_AS_USER_MENU_ITEM}
      />
      {isUserSelectorOpen ? (
        <UserSelector
          myId={id}
          onCancel={() => setUserSelectorOpen(false)}
          onUserSelected={user => impersonateAsUser(user)}
        />
      ) : null}
    </>
  );
};

export default ImpersonationToggle;
